<template>
  <div class="">
    <div class="return">
      <router-link :to="{ name: 'art-club-study-gallery' }">
        <font-awesome-icon class="icon" size="sm" icon="chevron-left" />
        Study gallery</router-link
      >
    </div>
    <loader v-if="loading" />
    <failed-to-load v-else-if="!loading && error" />
    <div v-else-if="!loading && submission" class="study-submission">
      <div class="submission__display">
        <img :src="submission.url" alt="" />
      </div>
      <div class="submission__author">
        <span class="title-large mb-2">
          {{ submission.user.displayName || submission.user.username }}</span
        >
        <span>
          <app-date prepend="submitted" :date="submission.createdAt" time />
        </span>
        <div class="submission__comment">
          <p>{{ submission.comment }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import maddyApi from '@/services/maddyApi';
import AppDate from '@/components/app/AppDate';
import Loader from '@/components/global/Loader';
import FailedToLoad from '@/components/global/FailedToLoad';

export default {
  name: 'StudySubmission',
  components: { AppDate, Loader, FailedToLoad },
  data: function() {
    return {
      submission: undefined,
      loading: false,
      error: null,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getSubmission();
    } catch (err) {
      this.error = err;
    }
    this.loading = false;
    this.$gtag.event('view_user_submission', {
      event_category: 'participation',
      event_label: 'Viewing a submission in gallery',
    });
  },
  computed: {
    locale: function() {
      return navigator.language;
    },
  },
  methods: {
    async getSubmission() {
      const x = await maddyApi.get(
        '/studies/submissions/' + this.$route.params.submission,
      );

      this.submission = x.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.study-submission {
  display: flex;
  flex-direction: column;
}

@media screen and (min-width: 768px) {
  .study-submission {
    flex-direction: row;
  }
}

.return {
  margin-bottom: 1rem;
  font-weight: 300;

  .icon {
    margin-right: 0.5rem;
  }
  a {
    background: color('primary');
    color: color('primary', 'text');
    height: 2rem;
    display: inline-flex;
    align-items: center;
    padding: 0 1rem;
  }
}

.submission {
  display: flex;
  flex: 1;

  &__display {
    flex: 4;
    justify-content: center;

    @media screen and (max-width: 767px) {
      margin-left: -16px;
      margin-right: -16px;
      margin-bottom: 16px;
    }

    img {
      max-width: 100%;
      align-self: center;
      // border-radius: 4px;
    }
  }

  &__author {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;

    .title-large {
      color: color('primary');
    }

    @media screen and (min-width: 768px) {
      padding: 16px;
    }
  }

  &__comment {
    padding: 1rem 0;

    p {
      font-size: 1rem;
      margin: 0;
    }
  }
}
</style>
